import { render, staticRenderFns } from "./productGroudsList.vue?vue&type=template&id=3da59d2e&scoped=true&"
import script from "./productGroudsList.vue?vue&type=script&lang=js&"
export * from "./productGroudsList.vue?vue&type=script&lang=js&"
import style0 from "./productGroudsList.vue?vue&type=style&index=0&id=3da59d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da59d2e",
  null
  
)

export default component.exports